import { useState } from "react";
import { Send } from "lucide-react";
import { Button } from "./Button";
import { Input } from "./Input";
import { ChatInputProps } from "../types";

const ChatInput: React.FC<ChatInputProps> = ({
  value: propValue,
  onChange,
  onSubmit,
  onSendMessage,

  inputRef,

  placeholder = "Type your message..."
}) => {
  // Use internal state if value is not provided from props
  const [internalValue, setInternalValue] = useState("");

  // Use either the prop value or the internal state
  const value = propValue !== undefined ? propValue : internalValue;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleSendMessage = () => {
    if (!value.trim()) return;

    if (onSendMessage) {
      onSendMessage(value);
      // Reset internal value if we're using that
      if (propValue === undefined) {
        setInternalValue("");
      }
    } else if (onSubmit) {
      onSubmit(value);
      // Reset internal value if we're using that
      if (propValue === undefined) {
        setInternalValue("");
      }
    }
  };

  const handleChange = (newValue: string) => {
    if (onChange) {
      onChange(newValue);
    } else {
      setInternalValue(newValue);
    }
  };

  return (
    <div className="flex gap-2">
      <Input
        ref={inputRef}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        // disabled={isDisabled}
        className="flex-1"
      />
      <Button
        onClick={handleSendMessage}
        // disabled={isDisabled || !value.trim()}
        className="shrink-0"
      >
        <Send className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ChatInput;
